import axios from "axios";
import { getUserDetail } from "./helper";
import { config } from "../config";

const axiosConfig = {
  baseURL: config.apiBaseUrl,
  timeout: 30000,
};

const instance = axios.create(axiosConfig);

instance.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = `Bearer ${getUserDetail()?.accessToken}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.data) {
      if (response.data?.isNotAuthorized) {
        localStorage.removeItem("userDetail");
        window.location.href = "/login";
      } else {
        return response;
      }
    } else {
      return response;
    }
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      axios.defaults.config.params = { token: getUserDetail()?.token };

      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
